<template>
  <div style="padding-bottom: 2%;">
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div class="col-12 col-md-9" style="padding-bottom: 2%;">
      <div class="invoiceBox">
        <p style="color: rgb(89, 149, 247); margin-top: 1%; margin-left: 2%; font-size: 11px;"> CURRENT BALANCE </p>
        <div class="innerInvoiceBox">
          <div>
            <strong style="margin-left: 2%; margin-top: 2%;">
              <u>Current Site Balance</u>
            </strong>
            <strong style="float:right; margin-right: 2%;">${{currentBalance}}</strong>
          </div>
          <div style="float: right; margin-right: 2%;">
            <p style="font-size: 14px;">As of {{currDate}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3" style="margin-top: 3%;">
      <button class="btn btn-success eDetailElement invoice-checkout-btn" @click="toCheckout" :disabled="currentBalance <= 0">
        Proceed to Checkout
      </button>
    </div>
    <div class="col-12 col-md-12 invoice-seperator" style="padding-bottom: 1%;">
      <div style="border-top: 2px solid rgb(89, 149, 247);">
        <p style="color: rgb(89, 149, 247); margin-top: 1%; margin-left: 2%; font-size: 11px;"> PAST STATEMENTS </p>
      </div>
    </div>
    <div class="col-11 col-md-8" style="margin-left: 2%;" v-for="(item, index) in currInvoiceList">
      <div class="invoiceItemBox" style="border: 1px solid grey; width: 100%; margin-top: 1%; margin-bottom: 1%;">
        <h5 v-if="item.type == 'Invoice'" style="top: 10px; position: relative; font-size: 14px; margin-left: 10px; float: left;">Invoice Number: {{item.invoiceNumber}} ({{formatDate(item.invoiceDate)}}) </h5>
        <h5 v-if="item.type == 'COO'" style="top: 10px; position: relative; font-size: 14px; margin-left: 10px; float: left;"> {{item.name}} </h5>
        <a class="view-statement-link" @click="viewStatement(item)" style="margin-top: 1%; margin-right: 1%; font-size: 14px;"> View Statement </a>
      </div>
    </div>
    <div class="col-1 col-md-4"></div>
    <h4 id="no-results" style="display: none;"> No Past Statements Found</h4>
    <div id="list-results" class="page-btns" style="display: inherit; margin-top: 1%;">
      <nav aria-label="Page navigation example"  v-for="curr in pages">
        <ul class="pagination">
          <li class="page-item" @click="changePage(curr - 1)">
            <a class="page-link" v-bind:class="{ 'active-page': isActive(curr) }">{{curr}}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</template>

<script>
import { getSiteInvoices, getSiteMasterBalance, getPayAbility, getSiteCOO } from '~/js/FormFunctions';
import BaseSelect from '@/components/BaseSelect';
import moment from 'moment';
import Vue from 'vue';
import Meta from 'vue-meta';

Vue.use(Meta);

export default {
  name: 'SiteInvoices',
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
  props: ['siteNumber'],
  components: { BaseSelect },

  data() {
    return {
      isValidNum: false,
      fetchingData: false,
      showModal: false,
      currDate: false,
      invoices: [],
      currInvoiceList: null,
      searchList: null,
      page: 0,
      pages: 0,
      currentBalance: 0,
      remainingCalls: 3,
    };
  },
  beforeMount() {
    const vm = this;
    this.fetchingData = true;

    getSiteInvoices(this.$parent.$parent.$attrs.siteNumber)
      .then((data) => {
        for (let i = 0; i < data.length; i++) {
          data[i].type = 'Invoice';
          vm.invoices.push(data[i]);
        }
        vm.currInvoiceList = vm.invoices.slice(vm.page * 5, vm.page * 5 + 5);
        vm.searchList = vm.invoices;
        vm.calcPages();
        vm.remainingCalls -= 1;
      })
      .catch(() => {
        vm.fetchingData = false;
        vm.remainingCalls -= 1;
      });

    getSiteCOO(this.$parent.$parent.$attrs.siteNumber)
      .then((data) => {
        for (let i = 0; i < data.length; i++) {
          data[i].type = 'COO';
          vm.invoices.push(data[i]);
        }
        vm.currInvoiceList = vm.invoices.slice(vm.page * 5, vm.page * 5 + 5);
        vm.searchList = vm.invoices;
        vm.calcPages();
        vm.remainingCalls -= 1;
      })
      .catch((error) => {
        vm.remainingCalls -= 1;
      });

    this.currDate = this.formatDate();
  },
  mounted() {
    const vm = this;
    getSiteMasterBalance(this.$parent.$parent.$attrs.siteNumber)
      .then((data) => {
        vm.currentBalance = data.balance.toFixed(2);
        vm.remainingCalls -= 1;
      })
      .catch(() => {
        vm.fetchingData = false;
        vm.remainingCalls -= 1;
      });
  },
  methods: {
    payFromList(index) {

    },
    calcPages() {
      if (this.searchList.length <= 5) {
        if (this.searchList.length == 0) {
          this.pages = 0;
        } else {
          this.pages = 1;
        }
      } else if (this.searchList.length % 5 != 0) {
        this.pages = parseInt(this.searchList.length / 5) + 1;
      } else {
        this.pages = this.searchList.length / 5;
      }
    },
    changePage(index) {
      this.currInvoiceList = this.searchList.slice(index * 5, (index * 5) + 5);
      this.page = index;
    },
    toCheckout() {
      this.fetchingData = true;
      getPayAbility(this.$parent.$parent.$attrs.siteNumber)
        .then((res) => {
          this.$router.push({ path: 'invoicecheckouttype', query: this.$route.query });
        })
        .catch((error) => {
          this.fetchingData = false;
        });
    },
    viewStatement(item) {
      if (item.type == 'Invoice') {
        this.$router.push({ name: 'ViewStatement', query: this.$route.query, params: { id: item.invoiceNumber, type: item.type } });
      } else if (item.type == 'COO') {
        this.$router.push({ name: 'ViewStatement', query: this.$route.query, params: { id: item.id, type: item.type } });
      }
    },
    formatDate(date) {
      if (date == undefined) {
        date = new Date();
      }
      const monthNames = [
        'January', 'February', 'March',
        'April', 'May', 'June', 'July',
        'August', 'September', 'October',
        'November', 'December',
      ];
      const newDate = new Date(date);
      return `${monthNames[newDate.getMonth()]} ${newDate.getDate()}, ${newDate.getFullYear()}`;
    },
    isActive(index) {
      index -= 1;
      return index == this.page;
    },
  },
  computed: {
    totalAmount() {
      if (this.invoices.length === 0) {
        return 0;
      }
      return this.invoices.map(i => i.invoiceAmount).reduce(sumReducer);
    },
  },
  watch: {
    remainingCalls() {
      if (this.remainingCalls == 0) {
        this.fetchingData = false;
        if (this.invoices.length == 0) {
          document.getElementById('no-results').style.display = '';
        }
      }
    },
  },
};

</script>
